export default "../fonts/pin-small.svg";